import { TimeSinceModule } from '@thisissoon/angular-timesince';
import { NotificationService } from './notification.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from './navbar.component';

@NgModule({
    imports: [ RouterModule, CommonModule,TimeSinceModule ],
    declarations: [ NavbarComponent ],
    exports: [ NavbarComponent ],
    providers:[NotificationService]
})

export class NavbarModule {}
